import { Flex } from "@chakra-ui/react";
import { NewHireJourney } from "models/v2/newHireJourney";
import MeetingsByList from "features/NewHireJourney/Views/MeetingsByList";

interface MeetingsTabProps {
  newHireJourney: NewHireJourney;
}

export default function MeetingsTab({ newHireJourney }: MeetingsTabProps) {
  return (
    <Flex direction="column" alignItems="flex-start" overflowX="scroll">
      <MeetingsByList newHireJourneyId={newHireJourney?.id} />
    </Flex>
  );
}
